import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getModeName } from "../../helpers";
import { Link } from "react-router-dom";
import Images from "../../Images";

const ViewModal = ({ setViewDetail, selectedData, apiData }) => {
  const onClose = () => setViewDetail(false);
  const isSettled = selectedData.settleStatus === 3;
  return (
    <Container>
      {/* Header */}
      <Header>
        <Title>View Details</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      {/* Top Section */}
      {/* <ProfileSection className="flex justify-between">
        <UserInfo>
          <span className="font-medium mb-0 text-lg">
            {selectedData?.tenantName}
          </span>
          <span className="text-sm text-gray-600">#{selectedData?.roomNum}, {selectedData?.propName}</span>
        </UserInfo>
        <div className="flex flex-col gap-0">
          <span className='text-gray-500 text-sm'>{'Amount Paid'}</span>
          <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.amount}</span>
        </div>
      </ProfileSection> */}
      <ProfileSection className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">

              <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
                  <UserImage
                    src={Images.Avatar}
                    alt={`Tenant Profile`}
                  />

              </div>
              <div className="flex flex-col">
                  <p className="text-md font-medium text-gray-800">
                      {capitalizeFirstLetter(selectedData?.tenantName || "")}
                  </p>
                  <p className="text-xs text-gray-400">
                    {capitalizeFirstLetter(
                      [
                        apiData?.flatNo && `#${apiData?.flatNo || ""},`,
                        apiData?.inventoryName
                      ]
                        .filter(Boolean)
                        .join(" ")
                    )}
                  </p>
              </div>

          </div>

          <div className="text-right">
              <p className="text-xs text-gray-400">Amount</p>
              <p className="text-lg font-bold text-gray-600">
                  ₹{selectedData?.amount || 0}
              </p>
          </div>
      </ProfileSection>

      {/* Content */}
      <Content>
        <ScrollableContent>
          <Wrapper>
            {/* Transaction Details */}
            <BtnWrapper>
              <SectionTitle>Transaction Details</SectionTitle>
            </BtnWrapper>
            <Section>
              <Row>
                <FlexCol>
                  <Label>Amount Paid</Label>
                  <Value>{'₹' + selectedData?.amount}</Value>
                </FlexCol>
                <FlexCol>
                  <Label>Payment Mode</Label>
                  <Value>{getModeName(selectedData?.mode)}</Value>
                </FlexCol>
              </Row>

              <Row>
                <FlexCol>
                  <Label>Collection Date</Label>
                  <Value>
                    {moment(selectedData?.collectionDate).format(
                      "DD, MMM YYYY, hh:mm A"
                    )}
                  </Value>
                </FlexCol>
                <FlexCol>
                  <Label>Due Date</Label>
                  <Value>
                    {selectedData?.dueDate ? moment(selectedData?.dueDate).format("DD, MMM YYYY") : '-'}
                  </Value>
                </FlexCol>
              </Row>

              <Row>
                <FlexCol>
                  <Label>Recorded By</Label>
                  <Value>{selectedData?.recordedBy}</Value>
                </FlexCol>
                <FlexCol>
                  <Label>Transaction ID</Label>
                  <Value>{selectedData?.gId}</Value>
                </FlexCol>
              </Row>
              {isSettled &&
                <>
                  <Row>
                    <FlexCol>
                      <Label>Settled On</Label>
                      <Value>{selectedData?.settledOn ? moment(selectedData?.settledOn).format("DD, MMM YYYY, HH:MM") : '-'}</Value>
                    </FlexCol>
                    <FlexCol >
                      <Label>UTR</Label>
                      <Value>{selectedData?.utrNo || '-'}</Value>
                    </FlexCol>
                  </Row>
                  {/* <Row className="grid-cols-1">
                    <FlexCol >
                      <Label>UTR</Label>
                      <Value>{selectedData?.utrNo}</Value>
                    </FlexCol>
                  </Row> */}
                </>
              }
              {(isSettled || selectedData?.bankRefNum)&&
                <>
                  <Row>
                    <FlexCol>
                      <Label>Bank Reference</Label>
                      <Value>{selectedData?.bankRefNum || '-'}</Value>
                    </FlexCol>
                    <FlexCol>
                      <Label>Gateway</Label>
                      <Value>{selectedData?.gateway === 1 ? 'PayU' : selectedData?.gateway === 4 ? 'PayTm' : selectedData?.gateway === 3 ? 'Easzebuzz' : 
                        '-'}</Value>
                    </FlexCol>
                  </Row>
                </>
              }
              {selectedData?.remarks && (
                <Row className="grid-cols-1">
                  <FlexCol>
                    <Label>Remarks</Label>
                    <Value>{selectedData?.remarks}</Value>
                  </FlexCol>
                </Row>
              )}
            </Section>



            {/* Documents Section */}
            <BtnWrapper>
              <SectionTitle>Documents</SectionTitle>
            </BtnWrapper>
            <Section>
              {selectedData?.docs && (
                <Row className="grid-cols-1">
                  <FlexCol>
                    <Label>Supporting Document</Label>
                    <Value className="text-blue-500 underline">
                      <Link
                        to={selectedData?.docs}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedData?.docs?.split("/").pop()}
                      </Link>
                    </Value>
                  </FlexCol>
                </Row>
              )}

              {selectedData?.receipt && (
                <Row className="grid-cols-1">
                  <FlexCol>
                    <Label>Rent Receipt</Label>
                    <Value className="text-blue-500 underline">
                      <Link
                        to={selectedData?.receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedData?.receipt?.split("/").pop()}
                      </Link>
                    </Value>
                  </FlexCol>
                </Row>
              )}
            </Section>
          </Wrapper>
        </ScrollableContent>
      </Content>
    </Container>
  );
};

export default ViewModal;

// ---------------- Styled Components ----------------
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1 gap-2`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-700 text-md break-all`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const UserImage = tw.img`w-12 h-10 rounded-full shadow-lg`;
